"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.default = (function (_a) {
    var error = _a.error;
    if (!error || !error.message) {
        return null;
    }
    return react_1.default.createElement("p", { className: 'form-error-message' }, error.message);
});
